/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:30:09
 */
export default {
  lang: "英语",
  landing: {
    name1: "Fungua Carlcare",
    name2: "Tengeneza nafasi",
    name3: "Ukiwa na Carlcare, unaweza angalia oda yako wakati wowote",
    name4: "",
    name5: "Telezesha hadi kulia",
    name6: "Uthibitishaji umekamilika",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for Infinix/Tecno/itel designated models.",
    name11: "Starting from ₱500, you can get your battery replaced with no labor fee.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Flat Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    // name16: "Lower and Transparent Pricing",
    // name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy a 3-month warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. If you join the flat price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.",
    name31: "Carlcare Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "Chagua mfano wa kifaa",
    name2: "Maelezo ya hitilafu:",
    name3: "Donoa ili uchague duka la huduma",
    name4: "Duka la Huduma:",
    name5: "Wakati wa Kuhifadhi:",
    name6: "Tafadhali eleza tatizo ya kifaa chako kwa kina!",
    name7: "Donoa ili uchague wakati wa kuwasili",
    name8: "Tafadhali ingiza maelezo wa mwasiliani iliyo sahihi ili tuweze kukufikia",
    name9: "Wakati wa uhifadhi uliopo ni kama ifuatavyo",
    name10: "Tafadhali weka nambari yako ya simu",
    name11: "Bei",
    name12: "Taarifa ya Kibinafsi:",
    name13: "Tafadhali ingiza jina lako",
    name14: "Wasilisha",
    name15: "GHAIRI",
    name16: "SAWA",
  },
  shops: {
    name1: "Kulingana na bidhaa utakayochagua, maduka yafuatayo yatakuhudumia!",
    name2: "Inakuja hivi karibuni kwenye maduka! Kaa na sisi!",
  },
  price: {
    name1: "Kampuni",
    name2: "Muundo",
    name3: "KIPENGEE",
    name4: "Bei",
    name5: "Kikumbusho cha Kirafiki:",
    name6: "Bei hizi ni za kurejelewa, na bei halisi ni kifaa katika hali ya kifaa chako.",
    name7: "Iwapo hakuna ishara maalum, kitengo cha bei ndicho kitengo cha sarafu ya nchi.",
    name8: "Samahani! Hakuna maelezo ya bei ilioko kwa eneo la sasa",
    name11:"Gharama ya Kazi",
    name12:"Bei Jumla",
    name13: "5. Ikiwa gharama ya kazi ni \"/\", ina maana kwamba gharama ya kazi inahitaji kushauriana na duka.",
    item_main_board: "Ubao mkuu",
    item_screen_frame: "Skrini (Fremu)",
    item_screen_screen_frame: "Skrini Mbadala (Fremu)",
    item_touch_screen: "Skrini ya Kugusa",
    item_camera: "\"Kamera\"",
    item_fixed_focus_camera: "Kamera ya Ulengaji Usiobadilika",
    item_auto_focus_camera: "Kamera ya Ulengaji Otomatiki",
    item_screen: "Skrini",
    item_secondary_screen: "Skrini ya Mbadala",
    item_fingerprint_module: "Moduli ya Alama ya Kidole",
    item_speaker: "Spika",
    item_receiver: "Kipokezi",
    item_small_board: "Ubao Mdogo",
    item_battery_cover: "Jalada la Betri",
    item_battery: "Betri",
    item_charger: "Chaja",
    item_usb_cable: "Kebo ya USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "hakuna data",
    name2: "Mtoa Huduma:",
    name3: "Huduma ya Muundo:",
    name4: "Simu:",
    name5: "Idadi ya Agizo:",
    name6: "Kiwango cha Huduma",
    name7: "Mazingira ya Huduma:",
    name8: "Tabia ya Huduma:",
    name9: "Ufanisi wa Huduma:",
    name10: "Ubora wa Huduma:",
    name11: "Tathmini ya Mteja",
    name12:"kwa",
    name13:"Imefungwa",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Fungua Carlcare",
    name1: "Tafadhali piga picha ya skrini ya maelezo ya uhifadhi na uhifadhi kama risiti ili kufikia huduma ya kipaumbele",
    name2: "Kuwasilisha kumefanikiwa",
    name3: "1.Kusafisha data",
    name4: "Tafadhali  chelezesha data ya kibinafsi iliyo muhimu kwenye simu yako kwa wakati",
    name5: "2. Lemaza nywila ya nguvu iliyowashwa",
    name6: "Kabla ya kuenda kwa duka la huduma,tafadhali",
    name7: "Duka la Huduma:",
    name8: "Wakati wa Kuhifadhi",
    name9: "Maelezo ya hitilafu",
    name10: "Mfano wa Kifaa",
    name11: "Nambari ya Oda",
    name12: "Maelezo ya Oda",
  },
  title: {
   
    name1: "Inaaunia nchi zifuatazo:",
    name2: "Chagua Muundo",
    name3: "Uhifadhi",
    name4: "Maelezo ya Duka la Huduma",
    name5: "Chagua Duka La Huduma",
  },
  error: {
    
    name1: "Hakuna data. Tafadhali angalia maelezo ya urekebishaji wako",
    name2: "Je, unahitaji usaidizi zaidi? Tafadhali wasiliana nasi.",
    name3: "Samahani, hakuna kituo cha Carlcare katika eneo la sasa.",
    name4: "Tafadhali chagua kituo cha huduma kwanza",
    name5: "Imefeli",
    name6: "Tafadhali chagua muundo wa kifaa kwanza",
    name7: "Maelezo",
    name8: "Tafadhali eleza mahitaji yako kwa kina",
    name9: "",
  },
  add1:{
    "name0": "sw",
    "name1": "Agizo lako limethibitishwa. Tunatarajia kuwasili kwako.",
    "name2": "Chagua mji",
    "name3": "Tafadhali weka nambari ya simu ya tarakimu %1$s.",
    "name4": "Saa za Wiki",
    "name5": "Jumatatu",
    "name6": "Jumanne",
    "name7": "Jumatano",
    "name8": "Alhamisi",
    "name9": "Ijumaa",
    "name10": "Jumamosi",
    "name11": "Jumapili",
    "name12": "Ingiza nchi na utafute"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Wengine",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Gusa ili Kuelekeza Upya",
    name3:"Fungua programu ya Carlcare ili kukadiria agizo",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Chagua Huduma",
    name7:"Kusafisha Bure",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "Taarifa isio sahihi",
    "cancelReason1": "Imeshindwa kufika kwa wakati",
    "cancelReason2": "Agizo linalofanana/sio agizo langu",
    "cancelReason3": "Kutofaulu hakujirudii",
    "cancelReason4": "Kwa ajili ya mtihani/uchunguzi/tukio/…",
    "cancelReason5": "Bei ya juu",
    "cancelReason6": "Uhaba wa nyenzo",
    "cancelReason7": "Hakuna huduma tofauti",
    "cancelReason8": "Duka liko mbali sana",
    "cancelReason9": "Duka limefungwa",
    "cancelReason10": "Mtazamo mbaya wa huduma",
    "cancelReason11": "Ubadilishaji/urekebishaji wa chapa zingine",
    "cancelReason12": "Haiwezi kupata duka",
    "cancelReason13": "Nyingine",
    "cancelOrder": "Ghairi oda",
    "reason_dialog_title": "Tafadhali tuambie sababu ya kughairi",
    "Cancel": "Ghairi",
    "OK": "SAWA",
    "name1": "Weka nambari ya kuthibitisha",
    "name2": "Msimbo wa uthibitishaji si sahihi",
    "repair_reservation_detail_canceled": "Agizo hili limekataliwa!",
    "purchase_cancel_dialog_content": "Je, unathibitisha kughairi agizo?",
    "yes": "Ndio",
    "no": "Hapana"
}
};
